export default {
  env: 'staging' as const,
  checkout: 'pk_test_49fb5cae-b3b1-40fd-bea6-e951f2492b20',
  hostname: 'https://local.dev.marshmallow.co',
  appUrl: 'https://local.dev.marshmallow.co',
  pcaapikey: 'EY51-AW78-UM56-NZ87',
  segmentkey: 'gNFRmf1e5XEODW9GS7aOSi3Xdm0mrbQc',
  intercomKey: 'jh4vt8fe',
  ravelinKey: 'publishable_key_test_4ArUnX6Gw1LzbU4J1ioE3qNrAUcUfOle',
  ravelinCookieDomain: '.marshmallow.co',
  logging: false,
  confusedTrackingUrl: 'https://follow.confusedpartnertest.co.uk',
  customerAccount: 'https://customer-portal.local.dev.marshmallow.co',
  plaidEnv: 'sandbox',
  plaidPublicKey: 'c972a242afdd539c5c38d6b35feb1f',
  plaidWebhook: 'https://local.dev.marshmallow.co/open-banking/updates',
  timeout: 45000,
  rollouts: 'phKQxxGM656xVVWm55tuy',
  smartcarClientId: '0f990022-b943-471c-a6b6-b96797e1a148',
  smartcarClientKey: '0c9168d5-b479-4f0a-bebc-1063474bb838',
  smartcarApiToken: '33ce1212-d20b-4376-87fb-cb774485b9b8',
  datadog: {
    environment: 'staging',
    applicationId: 'd017fa8e-834f-405c-a202-908d90128ca3',
    clientToken: 'pub41913af2956aabe4dd3bd2a1457b378d',
    traces: {
      enabled: true,
    },
  },
  sentry: {
    dns: 'https://7c4f289146c642ea8cdcae4ddf4e1587@o326695.ingest.sentry.io/6066978',
  },
}
